import { Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import { environment } from 'src/environments/environment';

@Directive({
  selector: '[imageSrcFromApi]'
})
export class ImageSrcDirective implements OnChanges {
  @Input('imageSrcFromApi') src?: string | ArrayBuffer | '';

  private apiUrl = environment.apiUrl.slice(0, -4); // API URL'inizi buraya yazın

  constructor(private el: ElementRef) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['src']) {
      const currentValue = changes['src'].currentValue;

      if (currentValue && currentValue.toString().toLowerCase().indexOf('/uploads/') > -1) {
        this.el.nativeElement.src = `${environment.imageUrl}${currentValue}`;
      } else {
        this.el.nativeElement.src = currentValue;
      }
    }
  }
}
